module.exports = __webpack_public_path__ + "img/thumbnail_WildBoar_f_normal.02f91cc6.png";